<template>
    <b-modal v-model="showModal" size="xl" @hidden="cancelar" button-size="md" hide-footer :title="prefix + title">
        <HistoricoTombamentoList :item="item"></HistoricoTombamentoList>

        <b-form-row>
            <div class="col-6"></div>
            <b-button pill style="height: 30px" @click="cancelar" size="sm" variant="danger">
                <div>
                    <b-icon icon="x-circle" />
                </div>
            </b-button>

        </b-form-row>
    </b-modal>
</template>

<script>

import HistoricoTombamentoList from '@/modules/patrimonio/historico-tombamento/HistoricoTombamentoList.vue';

export default {
    name: "ModalHistoricoTombamentoList",
    components: {
        HistoricoTombamentoList,

    },
    props: {
        item: Object,
        title: { type: String, default: " > Histórico Tombamento" },
        prefix: { type: String, default: "" },
    },
    data() {
        return {
            showModal: true,

        }
    },
    methods: {
        cancelar() {
            this.showModal = false;
            this.$emit('fecharModal');
        },

    }
}

</script>